import React from 'react'

const Pixel = ({ pixelId }) => (
  <script
    key={pixelId}
    dangerouslySetInnerHTML={{
      __html: `
fbq('init', '${pixelId}');
fbq('trackSingle', '${pixelId}', 'PageView');
`
    }}
  />
)

export default Pixel
